export default __webpack_public_path__ + "static/media/refLayout_5.18b0a3e5.png";